// generated by the plop

export class GetTemplateFormatList {
  static type = '[templateFormat] GetTemplateFormatList';
}
